import React from "react"
import styles from "./styles.scss"
import Companies from "pages/CompanyIndex/Companies"
import Header, { TYPES, SEARCH_BAR } from "components/Header"
import Ad from "components/Ad"
import Footer from "components/Footer"
import Waypoint from "react-waypoint"
import { getCompany, selectCompaniesAsArray } from "data/companies"
import { connect } from "react-redux"
import SearchBanner from 'components/SearchBanner'
import { getAdByCounty, selectAdByCounty } from 'data/ads'
import noadimage from 'images/image2.png'
import { contactPagePath } from 'utils/paths'

class CompanySearch extends React.Component {
  state = {
    showSearchBar: false,
    currentCounty: {}
  }
  componentDidMount() {
    const {companyId} = this.props.match.params 
    this.props.getCompany(companyId)
    const county = JSON.parse(localStorage.getItem("County"))
    county && this.props.getAdByCounty(county.id)
  }

  _handleWaypointEnter = () => {
    this.setState({ showSearchBar: false })
  }

  _handleWaypointLeave = () => {
    this.setState({ showSearchBar: true })
  }

  componentDidUpdate(prevProps) {
    const { companyId } = this.props.match.params
     if (companyId !== prevProps.match.params.companyId){
      companyId && this.props.getCompany(companyId)
      const county = JSON.parse(localStorage.getItem("County"))
      county && this.props.getAdByCounty(county.id)
    } else {
      return null;
    }
  }

  render() {
    const { showSearchBar } = this.state
    const { ad, ad : {adCounties} } = this.props
    const county = JSON.parse(localStorage.getItem("County"))
    return (
      <div className={styles.container}>
        <Header
          searchBar={
            showSearchBar
              ? SEARCH_BAR.SHOW_SEARCH_BAR
              : SEARCH_BAR.HIDE_SEARCH_BAR
          }
          headerType={TYPES.DARK_GRAY}
        />
        <div className={styles.contentWrapper}>
        {ad.imgurl && adCounties["0"].countyId === Number(county.id) ?
        <Ad image={ad.imgurl} title={ad.title} body={ad.body} href={ad.adUrl}/> :
        <Ad image={noadimage} title="Ledig annonsplats" body="Vill du annonsera här? kontakta oss för mer information." buttonText="Kontakta oss" href={contactPagePath()} />
        }
        <Waypoint
          onEnter={this._handleWaypointEnter}
          onLeave={this._handleWaypointLeave}
        />
        <SearchBanner />
        
          {this.props.companies && (
          <Companies companies={this.props.companies} />
          )}
          
        </div>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  companies: selectCompaniesAsArray(state, ownProps),
  ad: selectAdByCounty(state, ownProps)
})

export default connect(
  mapStateToProps,
  {
    getAdByCounty,
    getCompany,
  }
)(CompanySearch)


// WEBPACK FOOTER //
// src/pages/CompanySearch/index.jsx